import Head from 'expo-router/head';

import { ChallengeDetailScreen } from '@fhs/loyalty';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function ChallengeDetails() {
  return (
    <>
      <Head>
        <title>Challenge - Firehouse Subs</title>
      </Head>
      <ChallengeDetailScreen />
    </>
  );
}
